module.exports = __webpack_public_path__ + "img/6c9ea9c.png";